import React, { Fragment, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { uiActions } from '../store/ui';

import classes from './Notifications.module.scss';
import { NotificationData } from '../models/ui';
import { AppDispatch, RootState } from '../store';

const Notification: React.FC<Pick<NotificationData, 'message'>> = (props) => {
  return <div className={classes.notification}>{props.message}</div>;
};

interface NotficationsProps {
  notifications: Array<NotificationData>;
}

const NotificationsContainer: React.FC<NotficationsProps> = (props) => {
  return (
    <div className={classes.notification__container}>
      {props.notifications.length > 0 &&
        props.notifications.map((notification) => (
          <Notification key={notification.id} message={notification.message} />
        ))}
    </div>
  );
};

const portalElement = document.getElementById('overlays') as Element;

const Notifications = () => {
  const dispatch: AppDispatch = useDispatch();
  const notifications = useSelector((state: RootState) => state.ui.notifications);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (notifications.length) {
        dispatch(uiActions.removeNotification());
      }
      return () => clearTimeout(timer);
    }, 2000);
  }, [notifications, dispatch]);

  return (
    <Fragment>
      {ReactDOM.createPortal(
        <NotificationsContainer notifications={notifications} />,
        portalElement
      )}
    </Fragment>
  );
};

export default Notifications;
